module.exports = __webpack_public_path__ + "assets/media/1.5301b38e.wav";